<template>
    <div class="footer_container">
        <div class="inner">
            <div class="footer_links" v-if="linkList.length > 0">
                <span>友情链接：</span>
                <p class="links">
                    <a
                        class="link_item"
                        v-for="item in linkList"
                        :key="item.id"
                        :href="item.linkAddress"
                        target="_blank"
                    >
                        {{ item.linkName }}
                    </a>
                </p>
            </div>
            <div class="footer_site_info">
                <p>
                    版权:江西师范大学(Jiangxi Normal University)
                    ICP备案编号：赣洪备 2-4-3-2002018
                </p>
                <p>
                    学校地址：［瑶湖校区］江西省南昌市紫阳大道99号
                    邮政编码：330022 ［青山湖校区］江西省南昌市北京西路437号
                    邮政编码：330027
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            linkList: [],
        };
    },
    created() {},
    mounted() {
        this.getLinks();
    },
    methods: {
        getLinks() {
            let data = { isPublish: '1', current: 1, size: 100 };
            this.$api.linkList(data).then((res) => {
                this.linkList = res.data.list;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.footer_container {
    margin-top: 50px;
    border-top: 17px #e6e6e6 solid;
    .inner {
        width: 1110px;
        margin: 0 auto;
        position: relative;
        &::before,
        &::after {
            content: '';
            position: absolute;
            top: -17px;
            height: 17px;
        }
        &::before {
            left: 0;
            width: 736px;
            background-color: #d1cfcf;
        }
        &::after {
            right: 0;
            width: 374px;
            background-color: #a13838;
        }
        .footer_links {
            display: flex;
            justify-content: center;
            align-items: flex-start;
            padding: 20px 0;
            color: #a13838;
            border-bottom: 1px #e6e6e6 solid;
            span {
                padding: 3px 0;
                flex-shrink: 0;
            }
            .links {
                display: flex;
                flex-wrap: wrap;
            }
            .link_item {
                padding: 3px 10px;
                text-decoration: none;
                position: relative;
                color: #333;
                &:hover {
                    color: #a13838;
                }
                &::after {
                    content: '';
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    height: 14px;
                    width: 1px;
                    background-color: #333;
                }
                &:last-child::after {
                    display: none;
                }
            }
        }
        .footer_site_info {
            padding: 40px 0;
            color: #707070;
            line-height: 1.8;
            text-align: center;
        }
    }
}
</style>
